import { Label as LabelDs, Typography } from "@packages/ds";
import { Link } from "react-router-dom";
import styled from "styled-components";

import Button from "ds/Button";
import Checkbox from "ds/Checkbox";
import * as InputAll from "ds/Input";
import * as Sticker from "ds/Sticker";
import TextareaDs from "ds/Textarea";
import { semiBoldAlias } from "Libs/theme";

export const Wrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  margin: 0;
  background-color: var(--mode-bg-neutral-weakest);

  &.add-form {
    background-color: var(--mode-bg-neutral-weakest);
    border-radius: 0 0 4px 4px;
    margin-bottom: 16px;
  }
`;

export const FormWrapper = styled.form`
  padding: 32px;
  min-height: 200px;
  width: 100%;
  box-sizing: border-box;
`;

export const DeleteButton = styled(Button)`
  margin-left: auto !important;
`;

export const InputWrapper = styled.div`
  position: relative;
  max-width: 560px;
  width: 100%;
`;

export const Option = styled.div`
  display: flex;

  & label {
    white-space: normal;
  }
`;

export const VariableCheckbox = styled(Checkbox)`
  width: auto;
  margin: 0 5px 8px 5px;

  strong {
    ${semiBoldAlias()};
  }

  @media (max-width: 1024px) {
    & strong {
      width: fit-content;
      display: inline;
    }
    & strong::after {
      content: "\\A";
      white-space: pre-line;
      background: red;
    }
    & & + div {
      position: absolute;
      right: 0px;
    }
  }
`;

export const WarningSticker = styled(Sticker.Root)`
  display: flex;
  align-items: center;
  margin: 37px 0 0 0;
  line-height: 16px;
  gap: 5px;
  word-break: normal;
`;

export const Inherited = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  margin-bottom: 18px;
`;

export const Inactive = styled(Typography.BodyText)`
  display: flex;
  margin: 0 0 18px 0;
`;

const Badge = styled(Link)`
  display: flex;
  padding: 0 8px;
  border-radius: 2px;
  ${semiBoldAlias()};
  font-size: 12px;
  line-height: 24px;
  text-decoration: none;
`;

export const OverridingFrom = styled(Badge)`
  background-color: var(--mode-bg-warning-weak);
  color: var(--mode-text-neutral-default);
`;

export const InheritedFrom = styled(Badge)`
  background-color: var(--mode-bg-neutral-weaker);
  color: var(--mode-text-neutral-default);
`;

export const Toggle = styled.div`
  display: flex;
  label {
    margin-right: 16px;
    ${semiBoldAlias()};
    font-size: 13px;
  }
  input[type="checkbox"] {
    appearance: none;
    position: relative;
    display: inline-block;
    height: 18px;
    width: 32px;
    margin: 0;
    border-radius: 20px;
    outline: none;
    cursor: pointer;
    transition: background 0.3s;
    background-color: var(
      --input-periwinkle-grey-background-color,
      var(--periwinkle-grey)
    );
    &:after {
      position: absolute;
      content: "";
      display: block;
      left: 2px;
      top: 2px;
      width: 14px;
      height: 14px;
      transition:
        transform 0.3s ease,
        opacity 0.2s;
      border-radius: 50%;
      background-color: var(--section-snow-background-color, var(--snow));
      transform: translateX(0);
      box-shadow: 0px 1px 4px rgba(152, 160, 171, 0.4);
    }
    &:checked {
      background-color: var(
        --input-color-primary-600-background-color,
        var(--color-primary-600)
      );
      &:after {
        transform: translateX(14px);
      }
    }
  }
`;

export const Code = styled(Typography.Code)`
  margin: unset;
`;

export const InputLabelWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

export const InputRoot = styled(InputAll.Root)`
  margin-bottom: 16px;
`;

export const Label = styled(LabelDs)`
  margin-bottom: 0px;
`;

export const Textarea = styled(TextareaDs)`
  margin-bottom: 32px;
`;

export const NoteWrapper = styled.div`
  margin-bottom: 28px;
`;

export const NoteLabel = styled(Typography.Label)`
  font-weight: 400;
  display: block;
`;

export const NotesLink = styled(Button)`
  font-size: 12px;
  line-height: 20px;
`;
